/** Return URL of first product image, preferring web variant, ordered by position. */
export function getFirstProductImageUrl(images?: Array<{ url?: string | null; position?: number; variant?: string }> | null): string | undefined {
  if (!images?.length) return undefined;
  const sorted = [...images].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
  const web = sorted.find((img) => img.variant === 'web');
  return (web?.url ?? sorted[0]?.url) ?? undefined;
}
